import { render, staticRenderFns } from "./View.vue?vue&type=template&id=6ccf9928&scoped=true&"
import script from "./View.vue?vue&type=script&lang=js&"
export * from "./View.vue?vue&type=script&lang=js&"
import style0 from "../../style.css?vue&type=style&index=0&id=6ccf9928&prod&scoped=true&lang=css&"
import style1 from "./View.vue?vue&type=style&index=1&id=6ccf9928&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccf9928",
  null
  
)

export default component.exports